<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="12" md="6">
                <v-btn block text color="success" :loading="loading"  @click="newDialog = true"
                  :class="`${arabic?'arFont':'enFont'}`"
                >Verify Email</v-btn>
              </v-col>
              <v-col cols="12" v-if="false">
                <v-expansion-panels focusable>
                  <v-expansion-panel style="cursor:pointer;">
                  <v-expansion-panel-header>
                    <span style="font-size:12px;">STATS</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <line-chart :height="200" ref="chart" :chartdata="data" :options="options"/>
                  </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row row justify-center>
              <v-dialog v-model="newDialog" persistent max-width="1000">
                <v-card>
                  <v-card-title class="headline">Verify Email</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12" class="py-0">
                        <v-text-field
                          :label="i18n['email']"
                          outlined
                          dense
                          v-model="email"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="newDialog = false">cancel</v-btn>
                    <v-btn color="success" text @click.native="verifyEmail()">verify</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3"  v-for="(r, i) in resource.data" :key="'resource-'+i">
                <v-col cols="6" class="py-1">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    @keypress="noSpace($event)"
                    :label="i18n.slug"
                    v-model="r.domain"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    outlined
                    dense
                    :disabled="!r.warm"
                    hide-details
                    label="limit ((day - 1) * limit) + (day * 1000)"
                    v-model="r.limit"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-switch label="Active" v-model="r.send" hide-details @change="updateResource(r)"></v-switch>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-switch label="Warm" v-model="r.warm" hide-details @change="updateResource(r)"></v-switch>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-btn v-if="r.id" color="success" block text @click="updateResource(r)">
                    <v-icon left>save</v-icon>
                    <span>{{i18n.update}}</span>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-divider class="my-2"></v-divider>
                  <v-row class="pa-0 align-center">
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">SENT</div>
                      <div style="font-size:12px;">{{r.sent}}</div>
                    </v-col>
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">DELIVERED</div>
                      <div style="font-size:12px;">{{r.deliveries}}</div>
                    </v-col>
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">OPENED</div>
                      <div style="font-size:12px;">
                        {{r.opens}} 
                        <span v-if="r.open_rate" style="color:red;">({{parseFloat(r.open_rate).toFixed(2)}})%</span>
                      </div>
                    </v-col>
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">CLICKED</div>
                      <div style="font-size:12px;">
                        {{r.clicks}}
                        <span v-if="r.click_rate" style="color:red;">({{parseFloat(r.click_rate).toFixed(2)}} / {{parseFloat(r.specific_click_rate).toFixed(2)}})%</span>
                      </div>
                    </v-col>
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">BOUNCED</div>
                      <div style="font-size:12px;">{{r.bounces}}</div>
                    </v-col>
                    <v-col cols="2" class="py-0 text-center">
                      <div style="font-size:12px;">CREATED</div>
                      <div style="font-size:12px;">{{getFormat(r.created_at)}}</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-3" v-if="r.stats">
                  <v-expansion-panels focusable dense>
                    <v-expansion-panel>
                      <v-expansion-panel-header dense>
                        <v-row class="pa-0 align-center">
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0`" style="font-size:12px;" STATSHEADER>
                            HISTORY
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="pa-0 align-center">
                          <v-col cols="12" :class="`pa-0`" STATHEADS>
                            <v-row class="pa-0 align-center">
                              <v-col cols="4" class="py-0 text-center">
                                <div style="font-size:12px;">OPENED</div>
                              </v-col>
                              <v-col cols="4" class="py-0 text-center">
                                <div style="font-size:12px;">CLICKED</div>
                              </v-col>
                              <v-col cols="4" class="py-0 text-center">
                                <div style="font-size:12px;">DATE</div>
                              </v-col>
                            </v-row>
                            <v-divider class="my-1"></v-divider>
                          </v-col>
                          <v-col cols="12" :class="`pa-0`" v-for="(stat, ss) in r.stats" :key="'stat-' + ss + 'domain' + i" STATDATES>
                            <v-row class="pa-0 align-center">
                              <v-col cols="4" class="py-0 text-center">
                                <div style="font-size:12px;">
                                  {{stat.opens}} 
                                  <span v-if="stat.open_rate" style="color:red;">({{parseFloat(stat.open_rate).toFixed(2)}})%</span>
                                </div>
                              </v-col>
                              <v-col cols="4" class="py-0 text-center">
                                <div style="font-size:12px;">
                                  {{stat.clicks}}
                                  <span v-if="stat.click_rate" style="color:red;">({{parseFloat(stat.click_rate).toFixed(2)}} / {{parseFloat(stat.specific_click_rate).toFixed(2)}})%</span>
                                </div>
                              </v-col>
                              <v-col cols="4" class="py-0 text-center">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" v-if="r.created_at">
                                      <v-icon size="10">date_range</v-icon>
                                      {{stat.created_at.split('T')[0]}} |
                                      <v-icon size="10">schedule</v-icon>
                                      {{stat.created_at.split('T')[1].split('.')[0]}}</span>
                                  </template>
                                  <div class="text-center">
                                    <div v-if="stat.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{getFormat(stat.created_at)}}</div>
                                  </div>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        {
          name: 'domain',
          label: 'domain',
          type: 'text',
          required: true,
        },
        {
          name: 'limit',
          label: 'day_limit',
          type: 'number',
          required: true,
        },
        {
          name: 'name',
          label: 'cname',
          type: 'text',
          required: true,
        },
        {
          name: 'cname',
          label: 'cvalue',
          type: 'text',
          required: true,
        },
        {
          name: 'send',
          label: 'active',
          type: 'switch',
          required: true,
        },
        {
          name: 'warm',
          label: 'warm',
          type: 'switch',
          required: true,
        },
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      programs:[],
      countries:[],
      newDialog:false,
      email:null,
    }
  },
  
  methods: {
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('loadAllResource', {resource:`/${f.items}`})
            let maps = t.map(x=>{
              let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
              console.log(t)
              return{...x, text:t, [`${f.items}_id`]:x.id}
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    async loadSettingsItems(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let ks = ['countries', 'programs'];
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('getResource', {resource:`/${f}`})
            console.log('items', f, t)
            if(!t.error)
            t.forEach(x=> this.$store.state.i18n.en[x.slug] = x.en)
            t.forEach(x=> this.$store.state.i18n.ar[x.slug] = x.ar)
            t.forEach(x=> this.$store.state.i18n.fr[x.slug] = x.fr)
            this[f] = t
          }
          let rks = this.resourceKeys.filter(x=>x.type == 'select' && x.source == 'db')
          for (let i = 0; i < rks.length; i++) {
            const rk = rks[i];
            rk.data = this[rk.items].map(x=>{
              let text = x.slug ? this.i18n[x.slug] : x.name
              return{...x, [rk.name + '_id']: x.id, text}
            })
            console.log(rk.data)
          }
          this.loading = false
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:'/add-domain' + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
    async verifyEmail(){
      let r = await axios.post(this.api + '/verify-email', {email:this.email}, {headers}).then(x=>x.data)
      this.$emit('snackbarNotification', `An email is sent to ${this.email} please click link inside it`, 'success')
      this.newDialog = false
    },
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    // await this.loadItems()
    this.loadSettingsItems()
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>